module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-profile-page"
  }, [_c('div', {
    staticClass: "foo user-profile-tabs-wrap"
  }, [_c('div', {
    staticClass: "scrollmenu user-profile-tabs"
  }, [_c('div', {
    class: _vm.selectedButton === 'PROFILE' ? 'home-info-button-selected' : 'home-info-button',
    on: {
      "click": function($event) {
        return _vm.onTabClicked('PROFILE')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_user_profile_details')) + "\n        ")]), _vm._v(" "), (_vm.hiddenColumns == null ? true : !_vm.hiddenColumns.includes('MEMBERSHIP')) ? _c('div', {
    class: _vm.selectedButton === 'PAYMENTS' ? 'home-info-button-selected' : 'home-info-button',
    on: {
      "click": function($event) {
        return _vm.onTabClicked('PAYMENTS')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_user_payment_details')) + "\n        ")]) : _vm._e()])]), _vm._v(" "), (_vm.selectedButton === 'PROFILE') ? _c('div', {
    staticClass: "account--wrapper user-profile-account-wrap"
  }, [_c('div', {
    staticClass: "content user-profile-content",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "container user-profile-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card ui-card form--account user-profile-card"
  }, [_c('H3', {
    staticClass: "user-name-header"
  }, [_vm._v(_vm._s(_vm.model.name) + " " + _vm._s(_vm.model.surname))]), _vm._v(" "), _c('div', {
    staticClass: "row section-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.resetPassword
    }
  }, [_c('i', {
    staticClass: "ti-reload"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_reset_password')) + "\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_email')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.email),
      expression: "model.email"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "email",
      "placeholder": _vm.locale.t('label_email'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.model.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "email", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_name')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_name'),
      "name": "ime"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_surname')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.surname),
      expression: "model.surname"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_surname'),
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.model.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "surname", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), (!_vm.hiddenColumns.includes('BIRTHDAY')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_birthday')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.birthday),
      expression: "model.birthday"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "date",
      "placeholder": _vm.locale.t('label_birthday'),
      "name": "rodjendan"
    },
    domProps: {
      "value": (_vm.model.birthday)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "birthday", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (!_vm.hiddenColumns.includes('SHOES_SIZE')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_shoes_size')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.shoesSize),
      expression: "model.shoesSize"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_shoes_size'),
      "name": "rodjendan"
    },
    domProps: {
      "value": (_vm.model.shoesSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "shoesSize", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_phone')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.phone),
      expression: "model.phone"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_phone'),
      "name": "telefon"
    },
    domProps: {
      "value": (_vm.model.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "phone", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_role')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.role),
      expression: "model.role"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ROLE_USER",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_role_user')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ROLE_TRAINER"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_role_trainer')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ROLE_ADMIN"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_role_admin')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_username')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.username),
      expression: "model.username"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_role'),
      "name": "korisnicko"
    },
    domProps: {
      "value": (_vm.model.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "username", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), (_vm.showPartners) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_choose')) + " " + _vm._s(_vm.namesForPartner) + "a\n                        " + _vm._s(_vm.model.companyPayment != null ? ' [ ' + _vm.locale.t('label_current') + ' : ' + _vm.model.companyPayment + ' ]' : ''))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.companyPayment),
      expression: "model.companyPayment"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "companyPayment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.companiesPayments), function(item) {
    return _c('option', {
      domProps: {
        "value": item.name
      }
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.isEnableGender) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_gender')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.gender),
      expression: "model.gender"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "male",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_gender_male')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_gender_female')))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.model.companyPayment != null && _vm.model.companyPayment !== '' && _vm.showPartners) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_c('a', {
    on: {
      "click": _vm.deleteSaradnik
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_delete_trainer')) + "\n                        " + _vm._s(_vm.namesForPartner) + "a")])])])])]) : _vm._e(), _vm._v(" "), (_vm.customCategory !== '') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.customCategory))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.customCategory),
      expression: "model.customCategory"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "customCategory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("/")]), _vm._v(" "), _vm._l((_vm.customCategories), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                            " + _vm._s(item) + "\n                          ")])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.partnerCompanies.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_company_partners')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.partnerCompany),
      expression: "model.partnerCompany"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "partnerCompany", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.locale.t('label_without_company_partners')) + "\n                          ")]), _vm._v(" "), _vm._l((_vm.partnerCompanies), function(item) {
    return _c('option', {
      domProps: {
        "value": item.name
      }
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.userTypes.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_user_type')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.userType),
      expression: "model.userType"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "userType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.userTypes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.locale.t(item.label)) + "\n                          ")])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.isVisibleWaitingListStatus) ? _c('div', {
    staticClass: "filter-item wide user-profile-waiting-wrap"
  }, [_c('div', {
    staticClass: "scrollmenuStartFilter"
  }, _vm._l((_vm.waitingListStatuses), function(item) {
    return _c('span', {
      key: item.value,
      staticClass: "chips-group",
      on: {
        "click": function($event) {
          return _vm.onClickExpireWaiting(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip-filter"
    }, [_c('span', {
      class: _vm.getChipClassWaiting(item)
    }, [_c('span', {
      staticClass: "status-dot",
      class: _vm.statusClass(item.id)
    }), _vm._v("\n                            " + _vm._s(_vm.isSelectedWaiting(item) ? '✔ ' : '') + " " + _vm._s(item.label) + "\n                          ")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showUserAdditionalInfoLessonUrl) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_lesson_url')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.lessonUrl),
      expression: "model.lessonUrl"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_lesson_url'),
      "name": "lessonUrl"
    },
    domProps: {
      "value": (_vm.model.lessonUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "lessonUrl", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.showUserAdditionalInfo === true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_user_additional_info')) + " ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalInfo.userInfo),
      expression: "additionalInfo.userInfo"
    }],
    staticClass: "textarea-full",
    attrs: {
      "rows": "20"
    },
    domProps: {
      "value": (_vm.additionalInfo.userInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalInfo, "userInfo", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_SUPER_ADMIN') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Main Admin")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.isMainAdmin),
      expression: "model.isMainAdmin"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enableMyDictionary"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.isMainAdmin) ? _vm._i(_vm.model.isMainAdmin, null) > -1 : (_vm.model.isMainAdmin)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.isMainAdmin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "isMainAdmin", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "isMainAdmin", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "isMainAdmin", $$c)
        }
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.update
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_save')) + "\n                      ")])])])])], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'PAYMENTS') ? _c('div', {
    staticClass: "user-profile-payments-view"
  }, [_c('div', {
    staticClass: "foo user-profile-payments-head"
  }, [_c('H1', {
    staticClass: "header-h1"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_for')) + ": " + _vm._s(_vm.name))]), _vm._v(" "), (_vm.loyaltyProgramsEnabled) ? _c('div', {
    staticClass: "section-top"
  }, _vm._l((_vm.loyaltyProgramsList), function(item) {
    return _c('span', {
      staticClass: "loyalty-badge-item"
    }, [_c('p', {
      style: (_vm.loyaltyStyle(item))
    }, [_vm._v(_vm._s(_vm.locale.t('label_loyalty')) + " " + _vm._s(_vm.user.paidMonthsInRow > item ? item : _vm.user.paidMonthsInRow) + "/" + _vm._s(item))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.addPayment()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_payment_add_new')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row user-profile-payments-table-wrap"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width user-profile-payments-table-shell"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_from')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_to')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_date')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_price')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_number_of_trainings')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_type_trainings')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_partner')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_equipment')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_comment')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_edit')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_delete')))])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('tbody', _vm._l((_vm.orderedPayments), function(payment) {
    return _c('tr', [_c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_from')
      }
    }, [_vm._v(" " + _vm._s(_vm.formatDate(payment.paidDate)))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_to')
      }
    }, [_vm._v(_vm._s(_vm.formatDate(payment.expireDate)))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_payment_date')
      }
    }, [_vm._v(_vm._s(payment.paidTimestamp != null ? _vm.formatDate(payment.paidTimestamp) : '/'))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_mp_name')
      }
    }, [_vm._v(_vm._s(payment.membershipPackageName != null ? payment.membershipPackageName : '/'))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_price')
      }
    }, [_vm._v(_vm._s(payment.paidMoney) + "\n                  "), _c('i', {
      staticClass: "payment-paid-with-icon",
      class: _vm.getPaidWithIconClass(payment),
      attrs: {
        "title": _vm.getPaidWithLabel(payment)
      }
    }), _vm._v(" "), (payment.discount != null && payment.discount > 0) ? _c('b', {
      staticClass: "discount-label"
    }, [_vm._v("\n                    -" + _vm._s(payment.discount) + "%\n                  ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_number_of_trainings')
      }
    }, [_vm._v(_vm._s(payment.trainingNumber))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_payment_type_trainings')
      }
    }, [_vm._v(_vm._s(payment.trainingTypes))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_partner')
      }
    }, [_vm._v(_vm._s(payment.isForCompany ? 'Da' : 'Ne'))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_equipment')
      }
    }, [_vm._v(_vm._s((payment.additionalKit === null || payment.additionalKit.length === 0 ? '/' : payment.additionalKit)))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_payment_comment')
      }
    }, [_vm._v(_vm._s((payment.comment == null || payment.comment.length === 0 ? '/' : payment.comment)))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_edit')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.editPayment(payment.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_edit')) + "\n                  ")])]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deletePayment(payment.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n                  ")])])])
  }), 0)])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-email"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-package"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-info-alt"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58d7f15b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/UserProfile/UserProfile.vue
// module id = 790
// module chunks = 0